import { motion } from "framer-motion";
import { FileSignature, Car, UserCheck, FileText, Briefcase, Home, HeartPulse, Lock, PenTool } from "lucide-react";

const services = [
  { icon: FileSignature, t: "General Notarizations", d: "All standard documents notarized with accuracy and care." },
  { icon: Car, t: "Mobile Notary Services", d: "I come to your home, office, or preferred location." },
  { icon: UserCheck, t: "Power of Attorney", d: "POA documents notarized properly and confidentially." },
  { icon: FileText, t: "Affidavits", d: "Sworn statements and affidavits handled professionally." },
  { icon: Briefcase, t: "Business Documents", d: "Contracts, agreements, resolutions and more." },
  { icon: Home, t: "Real Estate Documents", d: "Deeds, titles, mortgages and closing paperwork." },
  { icon: HeartPulse, t: "Hospital & Nursing Home Visits", d: "Compassionate bedside notarization when it matters most." },
  { icon: Lock, t: "Jail Notarizations", d: "Reliable notary services for correctional facilities." },
  { icon: PenTool, t: "Loan Signing Services", d: "Professional, accurate loan document signing.", soon: true },
];

const card = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.19, 1, 0.22, 1], delay: (i % 3) * 0.1 } }),
};

export const Services = () => {
  return (
    <section id="services" className="bg-ivory py-24 lg:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <motion.p className="eyebrow text-goldDark mb-4"
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            Services
          </motion.p>
          <motion.h2 className="font-serif text-4xl sm:text-5xl tracking-tight"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
            How I Can <span className="gold-text italic">Help You</span>
          </motion.h2>
          <span className="block w-16 h-px bg-gold mx-auto mt-6" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.t}
                variants={card} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }}
                className="group relative bg-white rounded-2xl p-8 border border-taupe/20 shadow-[0_10px_40px_-24px_rgba(31,31,31,0.35)] hover:shadow-[0_24px_60px_-24px_rgba(198,161,91,0.5)] hover:-translate-y-1.5 transition-all duration-500"
                data-testid={`service-card-${i}`}
              >
                {s.soon && (
                  <span className="absolute top-5 right-5 text-[10px] tracking-widest uppercase text-goldDark border border-gold/40 rounded-full px-3 py-1">
                    Coming Soon
                  </span>
                )}
                <div className="h-14 w-14 rounded-xl border border-gold/30 grid place-items-center mb-6 group-hover:bg-gold/10 transition-colors duration-500">
                  <Icon size={26} strokeWidth={1.2} className="text-gold" />
                </div>
                <h3 className="font-serif text-xl mb-2">{s.t}</h3>
                <p className="text-ink/60 text-sm font-light leading-relaxed">{s.d}</p>
                <span className="block w-0 group-hover:w-12 h-px bg-gold mt-5 transition-all duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
